// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
  $w("#text371").show();
  }
});

export function columnStrip2_mouseIn(event) {
	//Add your code for this event here: 
}